import { ExpandIcon } from "@/assets/icons";
import classNames from "classnames";
import {
  MediaControlBar,
  MediaDurationDisplay,
  MediaPlayButton,
  MediaTimeDisplay,
  MediaTimeRange,
} from "media-chrome/react";
import { memo } from "react";
import PauseIcon from "../assets/pause.svg";
import PlayIcon from "../assets/play.svg";
import { useVideoPlayerContext } from "../context";
import styles from "../index.module.css";
import { ClipRangeSelector } from "./ClipRangeSelector";

interface ControlBarProps {
  handleExpand: () => void;
}

export const ControlBar = memo((props: ControlBarProps) => {
  const { handleExpand } = props;
  const context = useVideoPlayerContext();

  if (!context?.showControls) return null;

  const { enableClipRange, clipRange } = context;

  return (
    <div className="w-full flex items-center justify-end px-4 gap-3 bg-gradient-to-t from-[rgba(32,32,32,0.4)] to-transparent">
      <MediaControlBar
        className={classNames(styles.controlBar, "controller-bar")}
      >
        <MediaPlayButton className="bg-transparent mr-2">
          <PlayIcon className="w-[24px] h-[24px]" slot="play" />
          <PauseIcon className="w-[24px] h-[24px]" slot="pause" />
        </MediaPlayButton>
        <div className="flex items-center gap-2 flex-1 relative">
          {enableClipRange && clipRange ? (
            <ClipRangeSelector />
          ) : (
            <>
              <MediaTimeDisplay className="bg-transparent"></MediaTimeDisplay>
              <MediaTimeRange className={styles.timeRange}>
                <span slot="preview"></span>
              </MediaTimeRange>
              <MediaDurationDisplay />
            </>
          )}
        </div>
      </MediaControlBar>

      <ExpandIcon
        onClick={handleExpand}
        className="cursor-pointer text-white"
        aria-label="Expand video player"
        role="button"
      />
    </div>
  );
});

ControlBar.displayName = "ControlBar";
